
import { useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import ExperienceCategories from './components/ExperienceCategories';
import FeaturedRetreats from './components/FeaturedRetreats';
import InvestmentOpportunities from './components/InvestmentOpportunities';
import VideoShowcase from './components/VideoShowcase';
import Testimonials from './components/Testimonials';
import Newsletter from './components/Newsletter';

const HomePage = () => {
  useEffect(() => {
    // Update page title and meta description for homepage
    document.title = 'Talladega Alabama Glamping Investment Opportunities | OED Glamping';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'OED Glamping offers premium eco-luxury glamping experiences and profitable investment opportunities in Talladega, Alabama. Discover sustainable outdoor hospitality with geo domes, safari tents, and tiny homes. Start investing in the growing glamping industry today.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Talladega glamping, Alabama glamping investment, eco-luxury camping, glamping dealership, sustainable tourism');
    }

    // Add Homepage Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "OED Glamping - Talladega Alabama Glamping Investment Opportunities",
      "description": "OED Glamping offers premium eco-luxury glamping experiences and profitable investment opportunities in Talladega, Alabama. Discover sustainable outdoor hospitality with geo domes, safari tents, and tiny homes.",
      "url": "https://oedglampire.com/",
      "mainEntity": {
        "@type": "Organization",
        "name": "OED Glamping",
        "description": "Premium eco-luxury glamping experiences and investment opportunities in Talladega, Alabama"
      }
    });
    document.head.appendChild(script);

    return () => {
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript && existingScript.textContent?.includes('WebPage')) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <main>
        <header>
          <h1 className="sr-only">OED Glamping - Talladega Alabama Glamping Investment Opportunities</h1>
          <Hero />
        </header>
        <section aria-label="Experience Categories">
          <ExperienceCategories />
        </section>
        <section aria-label="Featured Retreats">
          <FeaturedRetreats />
        </section>
        <section aria-label="Investment Opportunities">
          <InvestmentOpportunities />
        </section>
        <section aria-label="Video Showcase">
          <VideoShowcase />
        </section>
        <section aria-label="Customer Testimonials">
          <Testimonials />
        </section>
        <section aria-label="Newsletter Signup">
          <Newsletter />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
